__turbopack_context__.v({
  "checkbox": "checkbox-module-scss-module__tjV9ga__checkbox",
  "checkmark": "checkbox-module-scss-module__tjV9ga__checkmark",
  "path": "checkbox-module-scss-module__tjV9ga__path",
  "placeholder": "checkbox-module-scss-module__tjV9ga__placeholder",
  "svg": "checkbox-module-scss-module__tjV9ga__svg",
  "wrapper": "checkbox-module-scss-module__tjV9ga__wrapper",
});
